import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";
import useAxios from "../utils/useAxios";
import {toast} from "react-toastify";
import {useHistory} from "react-router-dom";
import {CustomModal} from "./CustomModel/CustomModal";

const MenuList = ({
                      deleteEndpoint,
                      onDeleted,
                      confirmMessage,
                      successMessage,
                      errorMessage,
                      is_edit = false,
                      onEdit,
                      deleteConfirm = true,
                      is_share = false,
                      is_delete = true,
                      onShare,
                      editText,
                      getDeleteResponse = false,
                      onChangePlayer,
                      is_change_player= false,
                      is_merge = false,
                      onMerge,
                      is_export = false,
                      onExport,
                      title,
                      titleIcon = "menu",
                      // the floating dropdown positions itself with
                      // getBoundingClientRect() against the visual viewport,
                      // which iOS Safari resizes as the address bar
                      // collapses/expands - the menu ends up clipped or
                      // mispositioned there. A real modal sidesteps that
                      // entirely, same as ParticipantActionsModal already
                      // does for bracket-slot actions.
                      asModal = false
                  }) => {
    const [openMenu, setOpenMenu] = useState(false);
    const [menuStyle, setMenuStyle] = useState({});
    const { t } = useTranslation();
    const menuRef = useRef();
    const api = useAxios();
    const history = useHistory();

    useEffect(() => {
        // in modal mode the menu is a react-modal portal mounted outside
        // menuRef, and CustomModal already closes on overlay click/Escape -
        // this outside-click listener is only needed for the floating
        // dropdown variant
        if (asModal) return;

        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpenMenu(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [asModal]);

    const handleDelete = async () => {
        if (deleteConfirm) {
            const confirmed = window.confirm(
                confirmMessage || t("Are you sure you want to delete?")
            );
            if (!confirmed) return;
        }

        try {
            const response = await api.delete(deleteEndpoint + '/');
            if (onDeleted) {
                getDeleteResponse ? onDeleted(response) : onDeleted();
            }
            successMessage && toast.success(t(successMessage));
        } catch (error) {
            if (error.response.status === 500) {
                history.push('/500')
            }
            else if (error.response.status === 403) {
                toast.error(t("The club administrator does not have access to delete"));
            }
            else {
                toast.error(t(errorMessage));
            }
        }
    };

    const actions = [
        is_change_player && { icon: "edit", label: t("Change player"), onClick: onChangePlayer },
        is_edit && { icon: "edit-2", label: editText || t("Edit"), onClick: onEdit },
        is_export && { icon: "download", label: t("Export"), onClick: onExport },
        is_share && { icon: "link", label: t("Share"), onClick: onShare },
        is_merge && { icon: "git-merge", label: t("Union players"), onClick: onMerge },
        is_delete && { icon: "trash-2", label: t("Delete"), onClick: handleDelete, danger: true }
    ].filter(Boolean);

    if (asModal) {
        return (
            <div ref={menuRef} style={{ position: "relative" }}>
                <div className="options dots_menu" onClick={() => setOpenMenu(true)}>
                    <FeatherIcon icon="more-vertical" />
                </div>
                <CustomModal isOpen={openMenu} onClose={() => setOpenMenu(false)} compact>
                    <form className="modal-form">
                        {title && (
                            <div className="modal-sticky-header">
                                <h2><FeatherIcon icon={titleIcon} /> {title}</h2>
                            </div>
                        )}
                        <ul className="user-search-results">
                            {actions.map((a, i) => (
                                <li key={i} onClick={() => { setOpenMenu(false); a.onClick(); }} style={{ cursor: "pointer" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", color: a.danger ? "var(--bright-alarm)" : undefined }}>
                                        <FeatherIcon icon={a.icon} size={16} /> {a.label}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </form>
                </CustomModal>
            </div>
        );
    }

    return (
        <div ref={menuRef} style={{ position: "relative" }}>
            <div
                className={`options dots_menu ${openMenu ? 'active' : ''}`}
                onClick={(e) => {
                    if (!openMenu) {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const isDropup = window.innerHeight - rect.bottom < 150;

                        setMenuStyle({
                            position: 'fixed',
                            top: isDropup ? 'auto' : `${rect.bottom + 5}px`,
                            bottom: isDropup ? `${window.innerHeight - rect.top + 5}px` : 'auto',
                            right: `${document.documentElement.clientWidth - rect.right}px`,
                            zIndex: 9999,
                            width: "max-content"
                        });
                    }
                    setOpenMenu(!openMenu);
                }}
            >
                <FeatherIcon icon="more-vertical" />
            </div>
            <div className="dots_menu_container">
                <div className="relative input">
                    <div
                        className={`options-menu ${openMenu ? 'block_active' : 'block_inactive'}`}
                        style={{
                            ...(menuStyle.position ? menuStyle : {}),
                            transitionProperty: "opacity, transform, visibility"
                        }}
                    >
                        <div className="options-content-block">
                            {actions.map((a, i) => (
                                <div key={i} className="option pointer" onClick={a.onClick}>
                                    <FeatherIcon icon={a.icon} /> {a.label}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuList;
